// src/constants/elementTypes.js

export const elementTypes = [
  {
    name: 'Residential',
    category: 'building',
    color: '#FFE4B5',
    minSize: { width: 4, height: 3 },
    maxSize: { width: 8, height: 6 },
    properties: {
      maxFloors: 4,
      setback: 1.5,
      hasParking: true,
      requiresGreenSpace: true
    }
  },
  {
    name: 'School',
    category: 'building',
    color: '#87CEEB',
    minSize: { width: 6, height: 5 },
    maxSize: { width: 12, height: 10 },
    properties: {
      maxFloors: 3,
      setback: 2,
      hasPlayground: true,
      hasSportsField: true,
      requiresDropOffZone: true
    }
  },
  {
    name: 'Hospital',
    category: 'building',
    color: '#FF9999',
    minSize: { width: 8, height: 6 },
    maxSize: { width: 14, height: 12 },
    properties: {
      maxFloors: 8,
      setback: 3,
      hasEmergencyAccess: true,
      hasHelicopter: true,
      requiresQuietZone: true
    }
  },
  {
    name: 'Community Hall',
    category: 'building',
    color: '#DEB887',
    minSize: { width: 5, height: 4 },
    maxSize: { width: 10, height: 8 },
    properties: {
      maxFloors: 2,
      setback: 2,
      hasParking: true,
      isAccessible: true
    }
  },
  {
    name: 'Police Station',
    category: 'building',
    color: '#4682B4',
    minSize: { width: 4, height: 4 },
    maxSize: { width: 8, height: 8 },
    properties: {
      maxFloors: 3,
      setback: 2,
      hasEmergencyParking: true,
      requiresSecureZone: true
    }
  },
  {
    name: 'Library',
    category: 'building',
    color: '#DDA0DD',
    minSize: { width: 5, height: 4 },
    maxSize: { width: 10, height: 8 },
    properties: {
      maxFloors: 3,
      setback: 2,
      hasReadingGarden: true,
      isAccessible: true
    }
  },
  {
    name: 'Office',
    category: 'building',
    color: '#B8860B',
    minSize: { width: 5, height: 4 },
    maxSize: { width: 12, height: 10 },
    properties: {
      maxFloors: 12,
      setback: 2,
      hasParking: true,
      requiresGreenSpace: true
    }
  },
  {
    name: 'Supermarket',
    category: 'building',
    color: '#9370DB',
    minSize: { width: 6, height: 5 },
    maxSize: { width: 12, height: 10 },
    properties: {
      maxFloors: 2,
      setback: 2,
      hasLoadingBay: true,
      hasParking: true
    }
  },
  {
    name: 'Restaurant',
    category: 'building',
    color: '#FA8072',
    minSize: { width: 3, height: 3 },
    maxSize: { width: 6, height: 6 },
    properties: {
      maxFloors: 2,
      setback: 1,
      hasOutdoorSeating: true,
      requiresServiceAccess: true
    }
  },
  {
    name: 'Park',
    category: 'garden',
    color: '#90EE90',
    minSize: { width: 6, height: 6 },
    properties: {
      hasWalkways: true,
      hasBenches: true,
      hasPlayground: true,
      hasWaterFeature: true
    }
  },
  {
    name: 'Urban Forest',
    category: 'garden',
    color: '#228B22',
    minSize: { width: 8, height: 8 },
    properties: {
      hasNatureTrails: true,
      hasWildlife: true,
      requiresBuffer: true
    }
  },
  {
    name: 'Green Belt',
    category: 'garden',
    color: '#32CD32',
    minSize: { width: 4, height: 10 },
    properties: {
      isProtected: true,
      hasWalkways: true,
      requiresMaintenanceAccess: true
    }
  },
  {
    name: 'Eco-Pond',
    category: 'garden',
    color: '#4169E1',
    minSize: { width: 5, height: 5 },
    properties: {
      hasWetlands: true,
      supportsBiodiversity: true,
      requiresBuffer: true
    }
  },
  {
    name: 'Community Lake',
    category: 'garden',
    color: '#1E90FF',
    minSize: { width: 8, height: 8 },
    properties: {
      hasBoarding: true,
      hasWalkways: true,
      supportsRecreation: true
    }
  },
  {
    name: 'University',
    category: 'building',
    color: '#CD853F',
    minSize: { width: 12, height: 10 },
    maxSize: { width: 20, height: 16 },
    properties: {
      maxFloors: 6,
      setback: 4,
      hasCampusGreen: true,
      hasParking: true,
      requiresQuietZone: true
    }
  },
  {
    name: 'Industrial',
    category: 'building',
    color: '#A0522D',
    minSize: { width: 8, height: 6 },
    maxSize: { width: 16, height: 12 },
    properties: {
      maxFloors: 3,
      setback: 5,
      hasLoadingBay: true,
      requiresBuffer: true,
      requiresServiceRoad: true
    }
  },
  {
    name: 'Art Park',
    category: 'garden',
    color: '#FF69B4',
    minSize: { width: 6, height: 6 },
    properties: {
      hasDisplayAreas: true,
      hasPerformanceSpace: true,
      hasWalkways: true,
      supportsEvents: true
    }
  }
];